import { DateUtility } from '@utility/date';
import type { CatalogItemTab } from './tabs';

export const V2_TAB = {
  general: 'general',
  stock: 'stock',
  activity: 'activity',
  variations: 'variations',
  bundle: 'bundle',
} as const;

/* Variations and bundle components have a tab only when there is something to show. */
export function catalogItemV2Tabs(item: {
  variations: unknown[];
  bundle_components: unknown[] | null;
  /** EN-4134: absent from an older API, which has no Activity tab then. */
  activity?: unknown[];
}): CatalogItemTab[] {
  return [
    /* Channel listings and inventory sit on General, as in the prototype. */
    { id: V2_TAB.general, label: 'General' },
    /* EN-4134: what each channel was last sent, and the stock movements (inventory). */
    { id: V2_TAB.stock, label: 'Stock' },
    ...(item.variations.length
      ? [{ id: V2_TAB.variations, label: 'Variants' }]
      : []),
    ...(item.bundle_components
      ? [{ id: V2_TAB.bundle, label: 'Bundle components' }]
      : []),
    ...(item.activity ? [{ id: V2_TAB.activity, label: 'Activity' }] : []),
  ];
}

/** A missing value reads as an em dash. */
export const orDash = (value: string | number | null | undefined) =>
  value === null || value === undefined || value === '' ? '—' : String(value);

export const formatWhen = (value: string | null) =>
  orDash(value && DateUtility.formatDate(value));

/* EN-4134: what the rebuild did with a listing's quantity, in words. */
const STOCK_ACTIONS: Record<string, string> = {
  push: 'Sent to the channel',
  display_only: 'Held by the marketplace',
  not_supported: 'Not sent',
};

export const stockActionText = (action: string) =>
  STOCK_ACTIONS[action] ?? action.replace(/_/g, ' ');

/* A reason or status code as words ("no_observation" -> "No observation"). */
export const codeText = (code: string | null | undefined) =>
  code ? code.charAt(0).toUpperCase() + code.slice(1).replace(/_/g, ' ') : null;
